import axiosDeqart from '../axios';

export const getTeamMembers = async () => {
  try {
    const { data } = await axiosDeqart.get('/teams/my-team/members');
    return data?.data;
  } catch (err) {
    console.log('An error occurred while fetching team members', err.message);
    throw err;
  }
};

export const getTeamDetails = async () => {
  try {
    const { data } = await axiosDeqart.get('/teams/my-team');
    return data?.data;
  } catch (err) {
    console.log('An error occurred while getting team information', err.message);
    return err;
  }
};

export const createTeam = async (requestBody) => {
  try {
    const { data } = await axiosDeqart.post('/teams', requestBody);

    return data?.data;
  } catch (err) {
    console.log('An error occurred while creating a team', err.message);
    return err;
  }
};

export const joinTeam = async (teamId) => {
  try {
    const { data } = await axiosDeqart.patch(`teams/${teamId}`);
    return data?.data;
  } catch (err) {
    console.log('An error occurred while joining a team', err.message);
    return err;
  }
};

export const inviteToTeam = async (teamId, email) => {
  try {
    const { data } = await axiosDeqart.post(`teams/${teamId}`, { email });
    return data?.data;
  } catch (err) {
    console.log('An error occurred while inviting to a team', err.message);
    return err;
  }
};

export const removeTeamMember = async (memberId) => {
  try {
    await axiosDeqart.patch(`teams/my-team/members/${memberId}`);
    return true;
  } catch (err) {
    console.log('An error occurred while removing a team member', err.message);
    throw err;
  }
};
